import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import pendoApiRequest from "../../../../app/api/pendo/pendoApiRequest";

interface PendoDataState {
  apiKey: string | null;
  visitorIdPrefix: string | null;
  accountId: string | null;
  isEnabled: boolean;
  loading: boolean;
  error: string | null;
}

const initialState: PendoDataState = {
  apiKey: null,
  visitorIdPrefix: null,
  accountId: null,
  isEnabled: false,
  loading: false,
  error: null
};


export const fetchPendoApiKey = createAsyncThunk(
  'pendo/fetchApiKey',
  async (_, { rejectWithValue }) => {
    try {
      const response = await pendoApiRequest.getPendoData();
      if (!response || !response.ApiKey) {
        return rejectWithValue('Invalid response from API');
      }
      return response;
    } catch (error) {
      return rejectWithValue('Failed to fetch Pendo API key');
    }
  }
);

const pendoSlice = createSlice({
  name: 'pendo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendoApiKey.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendoApiKey.fulfilled, (state, action) => {
        state.loading = false;
        state.apiKey = action.payload.ApiKey;
        state.accountId = action.payload.AccountId;
        state.visitorIdPrefix = action.payload.VisitorIdPrefix;
        state.isEnabled = action.payload.ApiKey !== "false" && !!action.payload;

      })
      .addCase(fetchPendoApiKey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});


export default pendoSlice.reducer;